import axios from 'axios';
import * as userService from '../Services/userService';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18next from 'i18next';

/*global API */
const api = API;

const refreshTokenEndpoint = `${API}/api/Auth/RefreshToken`;
let isRefreshing = false;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

axios.interceptors.response.use(
  (success) => {
    // if (success.config.method === 'post') {
    //   toast('Item successfully created.', {
    //     type: 'success',
    //     position: 'top-right',
    //     autoClose: 1000,
    //   });
    // } else if (success.config.method === 'put') {
    //   toast('Item successfully updated.', {
    //     type: 'success',
    //     position: 'top-right',
    //     autoClose: 1000,
    //   });
    // }
    return success;
  },
  async (error) => {
    //const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
    let message = '';

    // Error 😨
    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      let pathName = window.location.pathname;

      if (error?.response?.status === 401 && pathName === '/recover') {
        console.log({ error });
        swal({
          title: 'Service error',
          text: error?.response?.data,
          icon: 'warning',
        });
        return;
      }

      if (error?.response?.status === 400 && pathName === '/register') {
        swal({
          title: 'Service error',
          text: pathName === '/register' ? error?.response?.data : error?.response?.data?.message,
          icon: 'warning',
        });
        return;
      }

      if ((error?.response?.status === 401 || error?.response?.status === 403) && pathName === '/login') {
        swal({
          title: 'Error logging in',
          text: error?.response?.status === 401 ? error?.response?.data : error?.response?.data?.message,
          icon: 'warning',
        });
        return;
      }

      if (error?.response?.status === 403) {
        swal({
          title: 'Forbidden',
          text: error?.response?.data?.message,
          icon: 'warning',
        });
        return;
      }

      if (error?.response?.status === 400) {
        message = error?.response?.data[0]?.description;
      } else if (error?.response?.status === 402) {
        swal({
          title: i18next.t('httpService.INSUFFICIENT_SUB'),
          text: i18next.t('httpService.INSUFFICIENT_SUB_EXPLANATION'),
          icon: 'warning',
        });
        return;
      }

      const originalRequest = error.config;
      let token = localStorage.getItem('token');
      let refreshToken = localStorage.getItem('refreshToken');

      // RefreshToken logic is in here
      if (error.response.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          try {
            // If it's already refreshing, wait until it's done
            //return lock.acquire('key', function () {
            await sleep(400);
            return axios(originalRequest);
            //});
          } catch (err) {
            // Handle error
            //console.log(err);
          }
        } else {
          originalRequest._retry = true;
          isRefreshing = true;

          const result = await axios
            .post(refreshTokenEndpoint, { token: token, refreshToken: refreshToken })
            .then(async (res) => {
              if (res?.status === 200) {
                // if (res.data?.errors && res.data?.errors[0] !== 'Token has been used') {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('refreshToken', res.data.refreshToken);

                originalRequest.headers = {
                  ...originalRequest.headers,
                  Authorization: `bearer ${res.data.token}`,
                };
                return await axios(originalRequest);
                // }
              } else {
                toast('Error updating refresh token.', {
                  type: 'error',
                  position: 'top-right',
                  autoClose: 1000,
                });
              }
            })
            .finally(() => {
              isRefreshing = false;
            });

          return result;
        }
      }

      if (pathName !== '/login') {
        if (error.response.status === 401) {
          swal({
            title: 'User session expired, please login again.',
            text: error.response.data.message,
            icon: 'error',
          }).then(async () => {
            // Checks for response status code 401 and redirect user to login page
            // Dont redirect if user is already on login app to prevent loosing state
            if (error.response.status === 401 && window.location.pathname !== '/login') {
              await localStorage.clear();
              window.location.replace('/login');
            }
          });
        } else {
          swal({
            title: 'Something went wrong. Error ' + error.response.status,
            text: error?.response?.data[0]?.description,
            icon: 'error',
          }).then(async () => {
            // Checks for response status code 401 and redirect user to login page
            // Dont redirect if user is already on login app to prevent loosing state
            if (error.response.status === 401 && window.location.pathname !== '/login') {
              await localStorage.clear();
              window.location.replace('/login');
            }
          });
        }
      }
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */ swal({
        title: 'Something went wrong.',
        message:
          'The request was made but no response was received, `error.request`, is an instance of XMLHttpRequest in the browser and an instance, of http.ClientRequest in Node.js',
        text: message,
        icon: 'error',
      });
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error message inside httpService', error.message);
    }

    return Promise.reject(message);
  }
);

axios.interceptors.request.use(
  (config) => {
    // Issue token if request url is our api. Prevent sending token in request which is not our api.
    if (config.url.toLowerCase().startsWith(api.toLowerCase())) {
      config.headers['Authorization'] = 'bearer ' + userService.getJwt();
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
